import AppActionTypes from './types';
import { action } from 'typesafe-actions';
import { MapSearchLocationHistory } from 'types';

export const initAppLoading = () => action(AppActionTypes.INIT_APP_LOADING);
export const initAppSuccess = () => action(AppActionTypes.INIT_APP_SUCCESS);
export const initAppFailure = () => action(AppActionTypes.INIT_APP_FAILURE);
export const setTheme = (theme: string) =>
  action(AppActionTypes.SET_APP_THEME, theme);

export const setAppLang = (language: string) =>
  action(AppActionTypes.SET_APP_LANGUAGE, language);

export const setAppUserRole = (role: string) =>
  action(AppActionTypes.SET_APP_USER_ROLE, role);

export const setAppLoginType = (type: string | null) =>
  action(AppActionTypes.SET_APP_AUTH_TYPE, type);

export const setMapSearchLocationHistory = (
  history: MapSearchLocationHistory | null
) => action(AppActionTypes.SET_MAP_SEARCH_LOCATION_HISTORY, history);

export const setHeaderPanelExpand = (req: any) =>
  action(AppActionTypes.SET_HEADER_PANEL_EXPAND, req);

export const setBaseMap = (baseMap: string, theme: string) =>
  action(AppActionTypes.SET_BASE_MAP, { baseMap, theme });

export const fetchAppSuccess = () => action(AppActionTypes.INIT_APP_SUCCESS);

export const fetchAppFailure = (errors: string) =>
  action(AppActionTypes.INIT_APP_FAILURE, errors);

export const setIsSignOutCompleted = (val: boolean) =>
  action(AppActionTypes.RESET_SSO_COMPLETE, val);

export const resetAppAuthState = () =>
  action(AppActionTypes.RESET_APP_AUTH_STATE_START);
export const resetAppAuthStateFinish = () =>
  action(AppActionTypes.RESET_APP_AUTH_STATE_FINISH);
export const setAppVisiblePanel = (qsValue: string) => ({
  type: AppActionTypes.SET_APP_VISIBLE_PANEL,
  payload: { appVisiblePanel: qsValue }
});

export const setShowCLOListing = (show: any | null) =>
  action(AppActionTypes.SET_SHOW_CLO_LISTING, show);

export const setShowInterstitialPage = (show: boolean) =>
  action(AppActionTypes.SET_SHOW_INTERSTITIAL_PAGE, show);
